import React from "react";

const CircularProgress = ({
  processedFileSize,
  totalFileSize,
  formatFileSize,
  progressPercentage,
}) => {
  // Use the passed progressPercentage instead of calculating it
  const progress =
    progressPercentage || (processedFileSize / totalFileSize) * 100;

  // SVG parameters - more responsive sizing
  const size = 160;
  const strokeWidth = 8;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  // Inline styles
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px",
    width: "100%",
    boxSizing: "border-box",
    maxWidth: "300px",
    margin: "0 auto",
  };

  const circleContainerStyle = {
    position: "relative",
    width: `${size}px`,
    height: `${size}px`,
    maxWidth: "100%",
  };

  const percentageContainerStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    animation: "fadeIn 0.5s ease-out",
    width: "100%",
  };

  const percentageTextStyle = {
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#2c3e50",
    margin: 0,
  };

  const detailsStyle = {
    color: "#718096",
    fontSize: "0.875rem",
    marginTop: "16px",
    animation: "slideUp 0.5s ease-out",
    animationFillMode: "forwards",
    textAlign: "center",
  };

  const styleKeyframes = `
    @keyframes fadeIn {
      from {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.5);
      }
      to {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
    }
    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    @keyframes progressPulse {
      0%, 100% { 
        stroke-opacity: 1;
      }
      50% { 
        stroke-opacity: 0.8; 
      }
    }
  `;

  return (
    <>
      <style>{styleKeyframes}</style>
      <div style={containerStyle}>
        <div style={circleContainerStyle}>
          {/* Use SVG for more accurate circular progress */}
          <svg
            width={size}
            height={size}
            viewBox={`0 0 ${size} ${size}`}
            style={{ maxWidth: "100%", height: "auto" }}
          >
            {/* Background Circle */}
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radius}
              fill="none"
              stroke="#e0e0e0"
              strokeWidth={strokeWidth}
            />

            {/* Progress Circle */}
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radius}
              fill="none"
              stroke="#4A90E2"
              strokeWidth={strokeWidth}
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              transform={`rotate(-90 ${size / 2} ${size / 2})`}
              style={{
                transition: "stroke-dashoffset 0.5s ease-in-out",
                animation: "progressPulse 1.5s infinite",
              }}
            />
          </svg>

          {/* Percentage Text */}
          <div style={percentageContainerStyle}>
            <p style={percentageTextStyle}>{Math.round(progress)}%</p>
          </div>
        </div>

        {/* File Size Details */}
        <div style={detailsStyle}>
          {`${formatFileSize(processedFileSize)} / ${formatFileSize(
            totalFileSize
          )} KB`}
        </div>
      </div>
    </>
  );
};

export default CircularProgress;
